// src/pages/Signup.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Signup() {
  // Removi o navigate pois não vamos redirecionar logo após cadastro.
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!name || !email || !password) {
      toast.error("Preencha todos os campos.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://api.sobevenda.com.br/api-proxy/affiliate/auth/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, password }),
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Erro no cadastro:", text);
        throw new Error("Erro ao criar conta. Verifique os dados.");
      }

      // Cadastro ok!
      setConfirmationMsg(true); // Mostra mensagem fixa de confirmação
      toast.success("Conta criada! Verifique seu e-mail para ativar sua conta.");
    } catch (err) {
      toast.error(err.message || "Erro ao criar conta.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <form
        onSubmit={handleSignup}
        className="w-full max-w-md bg-white p-8 rounded-xl shadow-md space-y-4"
      >
        <h2 className="text-2xl font-bold text-center">Criar Conta no SobeVenda</h2>

        {confirmationMsg && (
          <div className="bg-yellow-100 text-yellow-800 border border-yellow-400 p-4 rounded text-center mb-4">
            Cadastro realizado com sucesso! <br />
            <strong>Verifique seu e-mail</strong> e clique no link enviado para ativar sua conta antes de fazer login.
          </div>
        )}

        <input
          type="text"
          placeholder="Seu nome"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg"
          required
          disabled={confirmationMsg}
        />

        <input
          type="email"
          placeholder="Seu email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg"
          required
          disabled={confirmationMsg}
        />

        <input
          type="password"
          placeholder="Sua senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg"
          required
          disabled={confirmationMsg}
        />

        <button
          type="submit"
          disabled={loading || confirmationMsg}
          className={`w-full bg-blue-600 text-white font-bold p-3 rounded-lg hover:bg-blue-700 transition ${
            loading || confirmationMsg ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Criando conta..." : "Criar Conta"}
        </button>

        <p className="text-sm text-center text-gray-600">
          Já tem conta?{" "}
          <a href="/login" className="text-blue-600 hover:underline">
            Entrar
          </a>
        </p>
      </form>
    </div>
  );
}

export default Signup;
